import CardHeader from './CardHeader'

export { CardHeader }
export default CardHeader



// WEBPACK FOOTER //
// ./src/components/CardHeader/index.js